exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-toolbar a .btn{\n  margin-left: 5px;\n}", "", {"version":3,"sources":["/home/niko/Repositories/adminlte-react/src/components/content/Button.css"],"names":[],"mappings":"AAAA;EACE,iBAAgB;CAClB","file":"Button.css","sourcesContent":[".btn-toolbar a .btn{\n  margin-left: 5px;\n}"],"sourceRoot":""}]);

// exports
